import React, { useState, useRef, useEffect } from "react";
import { FlexContainer } from "BaseComponents/Flex/FlexContainer";
import styled, { css } from "styled-components";

const CheckBoxLabel = styled.label`
	width: 60px;
	border-radius: 15px;
	margin-right: 0.5rem;
	cursor: pointer;
	background-color: ${({ active, bgColor, theme }) =>
		active ? (bgColor ? bgColor : theme.colors.primary) : "#ddd"};
	&::after {
		content: "";
		display: block;
		border-radius: 50%;
		height: 23px;
		width: 23px;
		margin: ${({ active }) => (active ? "3px 3px 3px 33px" : "3px")};
		background: ${({ active, theme }) =>
			active ? theme.colors.white : theme.colors.darkgrey};
		box-shadow: 1px 3px 3px 1px rgba(0, 0, 0, 0.2);
		transition: all 0.2s ease;
	}
`;
const CheckBox = styled.input.attrs(({ disabled, active }) => ({
	disabled: disabled ? disabled : "",
	active: active ? active : false,
}))`
	opacity: 0;
	z-index: 1;
	width: 23px;
	display: none;
	border-radius: 15px;
	height: 23px;

	&:disabled + ${CheckBoxLabel} {
		background-color: ${({ theme }) => theme.colors.grey};
		cursor: not-allowed;

		&::after {
			background: ${({ theme }) => theme.colors.white};
			content: "";
			display: block;
			border-radius: 50%;
			width: 23px;
			height: 23px;
			margin-left: 33px;
			transition: 0.2s ease;
		}
	}
`;
const Flex = styled.div`
	display: flex;
	padding: 0.5rem 0;
	align-items: center;
`;

export const ToggleCheckbox = ({ bgColor, label, disabled, isSet, onChangeFunc }) => {
	const [active, set] = useState(isSet);
	const checkBoxRef = useRef(null);

	const onChange = () => {
		set(!active);
		onChangeFunc();
	};

	useEffect(() => {
		set(isSet);
	}, [isSet]);

	return (
		<Flex padding="0 5px" alignItems="center">
			<CheckBox disabled={disabled} id={label} type="checkbox" ref={checkBoxRef} />
			<CheckBoxLabel
				active={active}
				bgColor={bgColor}
				htmlFor={label}
				onClick={() => onChange()}
			/>
			<span>{label}</span>
		</Flex>
	);
};
